<div class="h-100 d-flex flex-column text-grey">
  <div #consumption class="d-flex flex-column">
    <div class="modal-header">
      <h4 class="modal-title text-center" id="modal-basic-title">{{ title }}</h4>
    </div>
    <div class="modal-body flex-grow-1">
      <div class="w-100">
        <div class="mb-2 d-flex flex-row w-100">
          <label class="form-label fw-bold w-15">Name</label>
          <label class="form-label flex-grow-1">: {{ fullName }}</label>
        </div>
        <div class="mb-2 d-flex flex-row w-100">
          <label class="form-label fw-bold w-15">Generation Date</label>
          <label class="form-label flex-grow-1">: {{ currentDate | date:"dd/MM/yyyy" }}</label>
        </div>
        <div class="mb-2  d-flex flex-row w-100">
          <label class="form-label fw-bold w-15">Period</label>
          <label class="form-label flex-grow-1">: {{ fromDate | date:"dd/MM/yyyy" }} - {{ toDate | date:"dd/MM/yyyy" }}</label>
        </div>
        <!-- <div class="mb-2  d-flex flex-row w-100">
          <label class="form-label fw-bold w-15">Consumption for</label>
          <label class="form-label flex-grow-1">: {{ consumptionType }}</label>
        </div> -->
      </div>
      <div>
        <h3 class="mt-3 ps-2 mb-0">Summary</h3>
        <table mat-table [dataSource]="summaryData" class="mat-elevation-z8 w-100 mt-3">
          <ng-container matColumnDef="no">
            <th mat-header-cell *matHeaderCellDef class="w-20 fw-bold"> # </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
      
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="w-20 fw-bold"> Type </th>
            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
            <td mat-footer-cell *matFooterCellDef> Total </td>
          </ng-container>
        
          <ng-container matColumnDef="units">
            <th mat-header-cell *matHeaderCellDef class="w-20 fw-bold"> Units Consumed </th>
            <td mat-cell *matCellDef="let element"> {{element.units}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
        
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef class="w-20 fw-bold"> Price </th>
            <td mat-cell *matCellDef="let element">{{element.price}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
        
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef class="w-20 fw-bold"> Total </th>
            <td mat-cell *matCellDef="let element"> {{element.total}} </td>
            <td mat-footer-cell *matFooterCellDef> {{getTotalCost()}} </td>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns" class="fw-bold"></tr>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary" (click)="generatePdf()">Download as PDF</button>
  </div>
  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default" zIndex = "1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    name="consumption"
    ></ngx-spinner
  >
</div>